export default {"src":"https://fishbrain.com/_next/static/media/1.39e8a2e1.svg","height":513,"width":513,"blurWidth":0,"blurHeight":0};